<template lang="pug">
    div
        grid-table-component(
            :headers="headers"
            :data="data"
            :is-paginated="true"
            :is-loading="isLoading"
            :pagination="setPagination()"
            @table:page-changed="checkPaginationChange($event)"
        )
            template(v-slot:nome="{ item }")
                i(:class="item.icon")
                span {{ item.nome }}

            template(v-slot:descricao="{ item }")
                span {{ item.descricao || 'Sem descrição' }}

            template(v-slot:dataAtualizacao="{ item }")
                span {{ item.dataAtualizacao }}


            template(v-slot:acoes="{ item }")
                div.actions-check
                    dropdown-component(
                    :list="montarAcoes(item)"
                    @input="onAction($event, item)"
                    :props="{ label: 'nome' }"
                    :is-select="false"
                    position="left"
                )


            template(v-slot:ativo="{ item }")
                span
                    chip-component(
                    :label="item.ativo ? 'Ativo' : 'Inativo'"
                    :background-color="item.ativo ? 'var(--primary-green)' : 'var(--secondary-red)'"
                    :icon="item.ativo ? 'mdi-link' : 'mdi-link-off'"
                    )

            template(v-slot:hasRelatedDocument="{ item }")
                span
                    chip-component(
                    :label="item.hasRelatedDocument ? 'Em Uso' : 'Não Uso'"
                    :background-color="item.hasRelatedDocument ? 'var(--primary-green)' : 'var(--secondary-red)'"
                    :icon="item.hasRelatedDocument ? 'mdi-link' : 'mdi-link-off'"
                    )

</template>

<script>
export default {
    name: 'TipoDocumentoTableComponent',

    props: {
        headers: {
            type: Array,
            default: () => [
                { text: 'Nome', value: 'nome' },
                { text: 'Descrição', value: 'descricao' },
                { text: 'Status', value: 'ativo' },
                { text: 'Última Atualização', value: 'dataAtualizacao' },
                { text: 'Uso', value: 'hasRelatedDocument' },
                { text: 'Ações', value: 'acoes' },
            ],
        },

        data: {
            type: Array,
            default: () => [],
        },

        paginacao: {
            type: Object,
            default: () => ({
                total: 0,
                pagina: 1,
                numeroPaginas: 0,
                quantidadePagina: 10,
                processos: {},
            }),
        },

        isLoading: {
            type: Boolean,
            default: false,
        },
    },

    methods: {
        checkPaginationChange({ page }) {
            this.$emit('table:page-changed', page);
        },

        setPagination() {
            return {
                page: this.paginacao.pagina,
                totalPages: this.paginacao.numeroPaginas,
                itemsPerPage: this.paginacao.quantidadePagina,
                totalItems: this.paginacao.total, // Usando a propriedade length do array de dados
                order: 'ASC',
            };
        },

        montarAcoes(item) {
            const acoes = [];

            if (item.ativo) {
                acoes.push({ nome: 'Inativar', id: 'inactivate', icon: 'mdi-link-off' });
            } else {
                acoes.push({ nome: 'Ativar', id: 'inactivate', icon: 'mdi-link' });
            }

            acoes.push({ nome: 'Editar', id: 'edit', icon: 'mdi-pencil' });

            if (!item.hasRelatedDocument) {
                acoes.push({ nome: 'Excluir', id: 'delete', icon: 'mdi-delete' });
            }

            return acoes;
        },

        async onAction(event, item) {
            try {
                switch (event.id) {
                    case 'inactivate':
                        this.$emit('action:inactivate', item);
                        break;
                    case 'edit':
                        this.$emit('action:edit', item);
                        break;
                    case 'delete':
                        this.$emit('action:delete', item);
                        break;
                    default:
                        break;
                }
            } catch (error) {
                console.error('Erro ao executar ação:', error);
            }
        },
    },
};
</script>

<style lang="scss" scoped>
/* styles.css */
.chip {
    width: 120px;
    /* Ajuste o tamanho conforme necessário */
    height: 15px;
    /* Ajuste o tamanho conforme necessário */
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    /* Ajuste o tamanho da fonte conforme necessário */
    color:

        white;
    /* Ajuste a cor do texto conforme necessário */
}

.actions-check button {
    display: flex;
    align-items: center;
    border: none;
    background: none;
    cursor: pointer;
    padding: 5px;
    font-size: 14px;
    color: var(--primary-blue);

    i {
        margin-right: 5px;
    }

    &:hover {
        color: var(--primary-dark-blue);
    }
}
</style>
